import { memo } from 'react';

import { type AnonymousAccountTrackingLocation } from '@air/analytics';

import {
  AnonymousSignUpForm,
  type AnonymousSignUpFormProps,
} from '~/components/AnonymousSignUpForm/AnonymousSignUpForm';
import { useAnonymousSignUpForm } from '~/components/AnonymousSignUpForm/hooks/useAnonymousSignUpForm';
import { ReCaptchaTermsInfo } from '~/components/AnonymousSignUpForm/ReCaptchaTermsInfo';

export type AnonymousSignUpFormWrapperProps = {
  onLoggedIn: () => void;
  trackLocation: AnonymousAccountTrackingLocation;
  shortId: string;
  objectId: string;
  objectType: 'clip' | 'board' | 'collection' | 'canvas';
} & Omit<AnonymousSignUpFormProps, 'onSubmitEmail' | 'onSignUp'>;

export const AnonymousSignUpFormWrapper = memo(
  ({ onLoggedIn, objectType, objectId, shortId, trackLocation, ...props }: AnonymousSignUpFormWrapperProps) => {
    const { onLoginWithEmail, onSignupWithEmailAndName } = useAnonymousSignUpForm({
      shortId,
      objectId,
      objectType,
      trackLocation,
      onLoggedIn,
    });

    return (
      <AnonymousSignUpForm {...props} onSubmitEmail={onLoginWithEmail} onSignUp={onSignupWithEmailAndName}>
        <div>
          <ReCaptchaTermsInfo />
        </div>
      </AnonymousSignUpForm>
    );
  },
);

AnonymousSignUpFormWrapper.displayName = 'AnonymousSignUpFormWrapper';
